<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-if="isLoggedIn"
      v-model="drawer"
      app
      clipped
    >
      <v-list dense>
        <v-list-item
          link
          :to="{ name: 'home' }"
        >
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-group prepend-icon="settings">
          <template v-slot:activator>
            <v-list-item-title>Configuración</v-list-item-title>
          </template>
          <v-list-item
            v-show="isCliente == 0"
            link
            :to="{name: 'empresa'}"
          >
            <v-list-item-action>
              <v-icon>mdi-briefcase-check</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Empresa</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="isCliente == 0"
            link
            :to="{name: 'usuario'}"
          >
            <v-list-item-action>
              <v-icon>mdi-account-key</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Usuarios</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="isCliente == 0"
            link
            :to="{name: 'mailtemplate'}"
          >
            <v-list-item-action>
              <v-icon>mdi-email</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Plantillas de Correo</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group prepend-icon="build">
          <template v-slot:activator>
            <v-list-item-title>Mantenimiento</v-list-item-title>
          </template>
          <v-list-item link :to="{name: 'libreta'}">
            <v-list-item-action>
              <v-icon>mdi-map</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Libreta de Direcciones</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="isCliente == 0"
            link
            :to="{name:'ciudadec'}"
          >
            <v-list-item-action>
              <v-icon>mdi-city</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Ciudades EC</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="isCliente == 0"
            link
            :to="{name:'cuenta'}"
          >
            <v-list-item-action>
              <v-icon>mdi-handshake</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Cuentas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="isCliente == 0"
            link
            :to="{name : 'agente'}"
          >
            <v-list-item-action>
              <v-icon>mdi-bank</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Agentes</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="isCliente == 0"
            link
            :to="{name : 'contacto'}"
          >
            <v-list-item-action>
              <v-icon>mdi-contacts</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Contactos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="isCliente == 0"
            link
            :to="{name : 'estatusg'}"
          >
            <v-list-item-action>
              <v-icon>mdi-book-information-variant</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Tipos de Estatus (Guía)</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="isCliente == 0"
            link
            :to="{name : 'estatusp'}"
          >
            <v-list-item-action>
              <v-icon>mdi-car-info</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Tipos de Estatus (PickUp)</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="isCliente == 0"
            link
            :to="{name : 'motivoundel'}"
          >
            <v-list-item-action>
              <v-icon>mdi-format-list-checkbox</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Motivos Undel</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="isCliente == 0"
            link
            :to="{name : 'cargosadicionales'}"
          >
            <v-list-item-action>
              <v-icon>mdi-cash</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Cargos Adicionales</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="isCliente == 0"
            link
            :to="{name:'courier'}"
          >
            <v-list-item-action>
              <v-icon>mdi-account-box</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Couriers</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="isCliente == 0"
            link
            :to="{name : 'agentease'}"
          >
            <v-list-item-action>
              <v-icon>mdi-lock</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Agentes Aseguradores</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-show="isCliente == 0"
            link
            :to="{name : 'cargartarifas'}"
        >
          <v-list-item-action>
            <v-icon>mdi-cash</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Tarifas de Flete</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
            v-show="isCliente == 0"
            link
            :to="{name : 'cargarpreciotramite'}"
        >
          <v-list-item-action>
            <v-icon>mdi-cash-check</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Precios de Tramite</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
            v-show="isCliente == 0"
            link
            :to="{name : 'coddescuento'}"
        >
          <v-list-item-action>
            <v-icon>mdi-cash-lock-open</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Códigos de Descuento</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
            v-show="isCliente == 0"
            link
            :to="{name : 'configtasas'}"
        >
          <v-list-item-action>
            <v-icon>mdi-cash-register</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Configuración de Tasas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group prepend-icon="mdi-airport">
          <template v-slot:activator>
            <v-list-item-title>Guías Aéreas</v-list-item-title>
          </template>
          <v-list-item
            link
            :to="{name: 'guias'}"
          >
            <v-list-item-action>
              <v-icon>mdi-folder-table</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Administrador de Guías</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :to="{name: 'exportacion'}"
          >
            <v-list-item-action>
              <v-icon>mdi-airplane</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Crear Exportación</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :to="{name: 'importacion'}"
          >
            <v-list-item-action>
              <v-icon>mdi-airplane mdi-rotate-90</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Crear Importación</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :to="{name: 'nacional'}"
          >
            <v-list-item-action>
              <v-icon>mdi-truck-check</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Crear Nacional</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :to="{name: 'cargarguias'}"
            v-if="isCliente == 0"
          >
            <v-list-item-action>
              <v-icon>mdi-briefcase-upload</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Cargar Guías Masivas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :to="{name: 'actualizarpodmasiva'}"
            v-if="isCliente == 0"
          >
            <v-list-item-action>
              <v-icon>mdi-truck-delivery</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Actualización POD Masivas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :to="{name: 'asignacionestatus'}"
            v-if="isCliente == 0"
          >
            <v-list-item-action>
              <v-icon>mdi-refresh</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Actualización Estatus Masiva</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :to="{name: 'transmisionmasiva'}"
            v-if="isCliente == 0"
          >
            <v-list-item-action>
              <v-icon>mdi-send</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Transmision Masiva</v-list-item-title>
              <v-list-item-action-text>Tramaco / ServiEntrega</v-list-item-action-text>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-item
          v-if="isCliente == 0"
          link
          :to="{name : 'runsheets'}"
        >
          <v-list-item-action>
            <v-icon>mdi-file-check</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>RunSheets</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item link :to="{name : 'pickups'}">
          <v-list-item-action>
            <v-icon>mdi-package-variant</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Pickups</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item link :to="{name : 'rastreo'}">
          <v-list-item-action>
            <v-icon>mdi-earth</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Rastrear</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-group prepend-icon="mdi-cart">
          <template v-slot:activator>
            <v-list-item-title>Compras en Linea</v-list-item-title>
          </template>
          <v-list-item
            v-show="isCliente == 0"
            link
            :to="{name: 'indicadorescl'}"
          >
            <v-list-item-action>
              <v-icon>mdi-speedometer</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Indicadores</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :to="{name: 'compraslinea'}"
          >
            <v-list-item-action>
              <v-icon>mdi-clock-alert</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Pre Alertas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :to="{name: 'cargarmanifiestocl'}"
            v-if="isCliente == 0"
          >
            <v-list-item-action>
              <v-icon>mdi-file-excel</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Cargar Manifiesto</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            link
            :to="{name: 'eliminarmanifiestocl'}"
            v-if="isCliente == 0"
          >
            <v-list-item-action>
              <v-icon>mdi-delete-forever</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Eliminar Manifiesto</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!--v-list-item
            v-show="isCliente == 0"
            link
            :to="{name: 'compraslineaestatus'}"
          >
            <v-list-item-action>
              <v-icon>mdi-clock-end</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Asignacion de Estatus</v-list-item-title>
            </v-list-item-content>
          </v-list-item-->
          <v-list-item
            v-show="isCliente == 0"
            link
            :to="{name : 'runsheetscl'}"
        >
          <v-list-item-action>
            <v-icon>mdi-file-check</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>RunSheets</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
            v-show="isCliente == 0"
            link
            :to="{name : 'cargarpodinfocl'}"
        >
          <v-list-item-action>
            <v-icon>mdi-briefcase-upload</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Carga POD Masiva</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
            v-show="isCliente == 0"
            link
            :to="{name : 'actualizacionmasivacl'}"
        >
          <v-list-item-action>
            <v-icon>mdi-bookmark-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Actualización Masiva</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
            link
            :to="{name : 'reportecl'}"
        >
          <v-list-item-action>
            <v-icon>mdi-file</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Reporte General</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-group prepend-icon="fact_check">
          <template v-slot:activator>
            <v-list-item-title>Reportes</v-list-item-title>
          </template>
          <v-list-item link :to="{name : 'reporteimp'}" v-if="isCliente == 0">
            <v-list-item-action>
              <v-icon>mdi-file</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Reporte de Importaciones</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link :to="{name : 'reporteimpups'}" v-if="isCliente == 0">
            <v-list-item-action>
              <v-icon>mdi-file</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Reporte de Importaciones UPS</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link :to="{name : 'reporteexp'}" v-if="isCliente == 0">
            <v-list-item-action>
              <v-icon>mdi-file</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Reporte de Exportaciones</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link :to="{name : 'reporteseg'}" v-if="isCliente == 0">
            <v-list-item-action>
              <v-icon>mdi-file</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Reporte de Seguros</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link :to="{name : 'reportereclamos'}" v-if="isCliente == 0">
            <v-list-item-action>
              <v-icon>mdi-file</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Reporte de Reclamos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link :to="{name : 'reportenacional'}" v-if="isCliente == 0">
            <v-list-item-action>
              <v-icon>mdi-file</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Reporte Nacional</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link :to="{name : 'reportegeneral'}" v-if="isCliente == 0">
            <v-list-item-action>
              <v-icon>mdi-file</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Reporte General</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link :to="{name : 'reportepickups'}" v-if="isCliente == 0">
            <v-list-item-action>
              <v-icon>mdi-file</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Reporte Pickups</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link :to="{name : 'reportegeneralcli'}" v-if="isCliente == 1">
            <v-list-item-action>
              <v-icon>mdi-file</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Reporte General</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link :to="{name : 'reportecotizaciones'}" v-if="isCliente == 0">
            <v-list-item-action>
              <v-icon>mdi-file</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Reporte Cotizaciones</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-divider></v-divider>
        <v-list-item link :to="{name : 'cotizar'}">
          <v-list-item-action>
            <v-icon>mdi-cash</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Cotizar</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      v-if="isLoggedIn"
      app
      clipped-left
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>
        <v-img
          :to="{name: 'home'}"
          src="images/logo.jpg"
          width="180px"
          height="60px"
        />
      </v-toolbar-title>
      <v-spacer />
      <v-btn
        v-if="isLoggedIn"
        icon
        @click="logOut"
      >
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
    <v-footer
      v-if="isLoggedIn"
      app
    >
      <span>&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  props: {
    source: String
  },
  data () {
    return {
      drawer: null,
      isLoggedIn: null,
      name: null,
      isCliente: 1
    }
  },
  created () {
    // this.$vuetify.theme.light = true
  },
  mounted () {
    this.isLoggedIn = localStorage.getItem('jwt')
    this.name = localStorage.getItem('user')
    this.isCliente = localStorage.getItem('cliente')
  },
  methods: {
    logOut () {
      this.isLoggedIn = null
      localStorage.removeItem('userid')
      localStorage.removeItem('user')
      localStorage.removeItem('jwt')
      localStorage.removeItem('cliente')

      this.$router.go('/login')
    }
  }
}
</script>
